<div class="container py-4">
  <div class="row justify-content-center">
    <div class="col-md-6 col-lg-5">
      <div class="card shadow-sm border-0">
        <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center">
          <h4 class="mb-0">
            <i class="fa-solid fa-unlock-keyhole me-2"></i>Cambiar Contraseña
          </h4>
          <button class="btn btn-light btn-sm" (click)="volverAtras()">
            <i class="fa-solid fa-arrow-left"></i> Volver
          </button>
        </div>

        <div class="card-body">
          <form [formGroup]="form" (ngSubmit)="cambiar()">
            <!-- Contraseña Actual -->
            <div class="mb-3">
              <label for="passwordActual" class="form-label">Contraseña Actual</label>
              <div class="input-group">
                <span class="input-group-text"><i class="fa-solid fa-lock"></i></span>
                <input
                  type="password"
                  id="passwordActual"
                  class="form-control"
                  formControlName="passwordActual"
                  required
                />
              </div>
             
            </div>

            <!-- Nueva Contraseña -->
            <div class="mb-3">
              <label for="nuevaPassword" class="form-label">Nueva Contraseña</label>
              <div class="input-group">
                <span class="input-group-text"><i class="fa-solid fa-key"></i></span>
                <input
                  type="password"
                  id="nuevaPassword"
                  class="form-control"
                  formControlName="nuevaPassword"
                  required
                />
              </div>
              
            </div>

            <!-- Mensajes de respuesta -->
            <div *ngIf="error" class="alert alert-danger">
              <i class="fa-solid fa-circle-exclamation me-2"></i>{{ error }}
            </div>
            <div *ngIf="success" class="alert alert-success">
              <i class="fa-solid fa-circle-check me-2"></i>{{ success }}
            </div>

            <!-- Botón Guardar -->
            <div class="d-grid">
              <button class="btn btn-success" [disabled]="loading || form.invalid">
                <i class="fa-solid fa-floppy-disk me-2"></i>{{ loading ? 'Guardando...' : 'Guardar Cambios' }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
